import ITask from './ITask';
import {
    PlayAnimation,
    StartAnimationClip,
} from '../../System/Animation/AnimationHelper';
import AnimationClip from '../../System/Animation/AnimationClip';

export class AnimationClipTask implements ITask<any> {
    public animationClip: AnimationClip;
    private skip: boolean = false;

    constructor(
        animationClip: AnimationClip,
        skip: boolean = false,
    ) {
        this.animationClip = animationClip;
        this.skip = skip;
    }

    public *execute(): IterableIterator<any> {
        if (this.skip) {
            StartAnimationClip(this.animationClip);
        } else {
            yield* PlayAnimation(this.animationClip);
        }
    }
}
